export enum CardKey {
  unknown = '??',
  c2 = 'c2',
  d2 = 'd2',
  h2 = 'h2',
  s2 = 's2',
  c3 = 'c3',
  d3 = 'd3',
  h3 = 'h3',
  s3 = 's3',
  c4 = 'c4',
  d4 = 'd4',
  h4 = 'h4',
  s4 = 's4',
  c5 = 'c5',
  d5 = 'd5',
  h5 = 'h5',
  s5 = 's5',
  c6 = 'c6',
  d6 = 'd6',
  h6 = 'h6',
  s6 = 's6',
  c7 = 'c7',
  d7 = 'd7',
  h7 = 'h7',
  s7 = 's7',
  c8 = 'c8',
  d8 = 'd8',
  h8 = 'h8',
  s8 = 's8',
  c9 = 'c9',
  d9 = 'd9',
  h9 = 'h9',
  s9 = 's9',
  ct = 'ct',
  dt = 'dt',
  ht = 'ht',
  st = 'st',
  ca = 'ca',
  da = 'da',
  ha = 'ha',
  sa = 'sa',
  cj = 'cj',
  dj = 'dj',
  hj = 'hj',
  sj = 'sj',
  cq = 'cq',
  dq = 'dq',
  hq = 'hq',
  sq = 'sq',
  ck = 'ck',
  dk = 'dk',
  hk = 'hk',
  sk = 'sk',
}
